import { InsulationElement } from "./InsulationElement";
import { InsulationElementType } from "../../constants/combo/InsulationElementType";
export class RoofElement extends InsulationElement {
  getElementType = () => InsulationElementType.ROOF;
  getMaxWidth = () => 50.0;
}
